<!-- MOBILE MENU -->
<div id="mobile-menu" [ngClass]="{'open': showMobileMenu}">
	<div class="menu-closer" (click)="hideMobileMenu()"></div>

	<div class="menu-content scroll-y">
		<div class="menu-header text-shadow dbrown-bg large">
			<img *ngIf="whitelabelLogo" [src]="whitelabelLogo">
			<ng-container *ngIf="!whitelabelLogo">
				<img class="logo" src="/resources/img/logo/logo_white_no_text.svg" alt="logo" />
			</ng-container>
			<div class="user-info">
				<i class="fa fa-user"></i> {{ displayName }}<span class="publication-indicator" *ngIf="publication"> - {{ publication.label || publication.name || publication.vhost }}</span>
			</div>
		</div>

		<bb-notification-center [hidden]="!userInfo || !hasPublication"></bb-notification-center>
		
		<div [hasPermission]="'media library'" [hidden]="!userInfo || !hasPublication" class="global-search">
			<button type="button" class="button join-left icon-only" (click)="doSearch()"><i class="fa fa-search"></i></button>
			<span class="search-input"><input #search (keyup.enter)="doSearch()" type="search" placeholder="{{ 'SEARCH_FOR_MEDIACLIPS' | translate }}" class="search join-right" [(ngModel)]="searchString" data-cy="bb-nav-search-input-mobile"/></span>
		</div>

		<ul>
			<li routerLinkActive="active">
				<a [routerLink]="[publication?.ovpCustomHomeUrl || '/home']"><i class="fa fa-home"></i>{{ 'HOME' | translate }}</a>
			</li>
			<li data-cy="media-library" (click)="setOpenMenu('library')" [hasPermission]="'media library'" [ngClass]="{open: openMenu === 'library', active: menuActive === 'library'}">
				<a><i class="fa fa-book"></i><span>{{ 'MEDIA_LIBRARY' | translate }}</span></a>
				<!-- <div ng-include src="'app/components/library/library-menu.html'"></div> -->
				<bb-library-menu></bb-library-menu>
			</li>
			<li (click)="setOpenMenu('adservices')" [hasPermission]="'ad services'" [ngClass]="{open: openMenu === 'adservices', active: menuActive === 'adservices'}">
				<span class="adblock-overlay" *ngIf="adBlocker">{{ 'PLEASE_DISABLE_AD_BLOCKER' | translate }}</span>
				<a><i class="fa fa-bullhorn"></i><span>{{ 'AD_SERVICES' | translate }}</span></a>
				<!-- <div ng-include src="'app/components/adservices/adservices-menu.html'"></div> -->
				<bb-adservices-menu></bb-adservices-menu>
			</li>
			<li (click)="setOpenMenu('analytics')" [hasPermission]="'analytics'" [ngClass]="{open: openMenu === 'analytics', active: menuActive === 'analytics'}" class="analytics-button">
				<a><i class="fa fa-line-chart"></i><span>{{ 'ANALYTICS' | translate }}</span></a>
				<!-- <div ng-include src="'app/components/analytics/analytics-menu.html'"></div> -->
				<bb-analytics-menu></bb-analytics-menu>
			</li>
		</ul>
	
		<ul class="useractions" >
			<hr />
			<bb-user-menu></bb-user-menu>
		</ul>
	</div>
</div>
<!-- END MOBILE MENU -->

<!-- DESKTOP MENU -->
<div id="navbar">
	<a [routerLink]="[publication?.ovpCustomHomeUrl || '/home']" id="logo" [ngClass]="{'notprod': environment !== 'prod', 'whitelabel': whitelabelLogo}">
		<img *ngIf="whitelabelLogo" [src]="whitelabelLogo">
		<ng-container *ngIf="!whitelabelLogo">
			<img class="logo" src="/resources/img/logo/logo_white_no_text.svg" alt="logo" />
		</ng-container>
	</a>

	<div class="environment-container">
		<span *ngIf="environment !== 'prod'" class="environment">{{environment}}</span>
	</div>
	<nav *ngIf="!userInfo || !hasPublication" id="login-menu" class="main-menu">
		<ul>
			<li class="active"><a (click)="dropdown = !dropdown">{{ 'ONLINE_VIDEO_PLATFORM' | translate }}<i class="fa fa-chevron-down"></i></a></li>
			<li><a href="https://bluebillywig.com/" target="_blank">{{ 'BLUE_BILLYWIG' | translate }}</a></li>
			<li><a href="https://support.bluebillywig.com" target="_blank">{{ 'SUPPORT' | translate }}</a></li>
			<li class="right"><a (click)="showAbout()">{{ "CONTACT" | translate }}</a></li>
		</ul>
	</nav>

	<nav *ngIf="userInfo && hasPublication" id="contextselector" class="main-menu">
			<ul>
			<li *ngIf="mediaclipsRight" [ngClass]="{'active': menuActive === 'library'}"><a [routerLink]="['/library/mediaclips']"><i class="fa fa-book"></i><span>{{ 'MEDIA_LIBRARY' | translate }}</span></a></li>
			<li *ngIf="adServicesRight" [ngClass]="{'active': menuActive === 'adservices'}">
				<span class="adblock-overlay" *ngIf="adBlocker">{{ 'PLEASE_DISABLE_AD_BLOCKER' | translate }}</span>
				<a [routerLink]="['/adservices/adunits']"><i class="fa fa-bullhorn"></i><span>{{ 'AD_SERVICES' | translate }}</span></a>
			</li>
			<li [hasPermission]="'analytics'" [ngClass]="{'active': menuActive === 'analytics'}"><a [routerLink]="['/analytics/statistics']"><i class="fa fa-line-chart"></i><span>{{ 'ANALYTICS' | translate }}</span></a></li>
		</ul>
	</nav>

	<div (clickOutside)="showUserinfo = false" [hidden]="!userInfo || !hasPublication" id="userinfo" class="clearfix">
		<div class="quickinfo">
			<a [ngClass]="{'active': showUserinfo}" (click)="showUserinfo = !showUserinfo">
				{{ displayName }}<span class="publication-indicator" data-cy="publication-menu" *ngIf="publication">&nbsp;-&nbsp;{{ publication.label || publication.name || publication.vhost }}</span><i class="fa fa-cogs"></i>
			</a>
			<div class="hubspot">
				<bb-hubspot *ngIf="environment === 'prod'" (click)="openHubspotChat()" (clickOutside)="closeHubspotChat()"></bb-hubspot>
			</div>
		</div>
		<div [hidden]="!showUserinfo" class="dropdown arrow-top-right"><bb-user-menu (showUserMenu)="showUserMenu($event)"></bb-user-menu></div>
	</div>
	
	<bb-notification-center [hidden]="!userInfo || !hasPublication"></bb-notification-center>

	<div *ngIf="userInfo && hasPublication" [hasPermission]="'media library'" class="global-search">
		<input #search type="search" (keyup.enter)="doSearch()" placeholder="{{ 'SEARCH_FOR_MEDIACLIPS' | translate }}" class="search join-right" [(ngModel)]="searchString" data-cy="bb-nav-search-input-desktop" />
	 	<button type="button" class="button join-left icon-only" (click)="doSearch()"><i class="fa fa-search"></i></button>
	</div>

</div>
<!-- END DESKTOP MENU -->
